export default "__VITE_ASSET__D6AqBqdh__"